import { IAnaliticData } from '../redux/duck/legado/accountingApp/analiticData/interface/reduxInterface';
import { capitalize } from './masks';

// ISPB da Fiducia zero-padded (VARCHAR(8) no core)
export const ISPB_FIDUCIA = '04307598';

// Compara ISPB de forma defensiva: aceita numero legado (4307598) e string
// zero-padded ('04307598'), normalizando com padStart(8)
export function isIspbFiducia(ispb?: number | string | null): boolean {
  if (ispb === null || ispb === undefined) {
    return false;
  }
  return String(ispb).padStart(8, '0') === ISPB_FIDUCIA;
}

// Check props and return partner name string
export function setPartner(id: number, partnerListState: any) {
  let partnerName = '';
  partnerListState.filter((partner: any) => {
    if (partner.id === id) {
      partnerName = capitalize(partner.razao_social);
    }
    return partnerName;
  });
  return partnerName;
}

export function defineAccountType(accountFormat: any) {
  if (accountFormat !== undefined) {
    switch (accountFormat) {
      case 1:
        return 'Movimento';

      case 2:
        return 'Escrow';

      case 3:
        return 'Consignada';

      default:
    }
  }
  return accountFormat;
}

export const typeAccount = {
  '-': '',
  Escrow: 'Escrow',
  Consignada: 'Consignada',
  Movimento: 'Movimento',
};
export const TpRetorno = {
  '-': '',
  Realizado: 'R',
  Pendente: 'P',
  Cancelado: 'C',
  'Erro | Estornado (E)': 'E',
  'Erro | Estornado (G)': 'G',
};

export const codmensagem = {
  '': '-',
  'ANTECIPAÇÃO DE RECEBIVEL': 'ASLC032',
  'RECEBIMENTO DE DOMICILIO CRÉDITO': 'ASLC022',
  'RECEBIMENTO DE DOMICILIO DEBITO': 'ASLC024',
  'TARIFA DE ABERTURA DE CONTA CONSIGNADA': 'TARIFA_ABERTURA_CONTA_CONSIGNADA',
  'PAGAMENTOS DE BOLETO': 'Boleto',
  'BOLETO LIQUIDADO': 'BOLETO_CREDITO',
  'CARTAO DEBITO': 'CARTAO_00_PURCHASE',
  'CARTAO SAQUE': 'CARTAO_01_CASH_WITHDRAW',
  'COMPRA DE CRIPTO': 'CRIPTO_COMPRA',
  'VENDA DE CRIPTO': 'CRIPTO_VENDA',
  Pix: 'Pix',
  'Pix DEVOLUÇÃO': 'Pix_Devolucao',
  'RECARGA DE CELULAR': 'Recarga',
  'PAGAMENTO DE TARIFA BC': 'SLB0002',
  'TRANSFERENCIA ENVIADA PARA IF': 'STR0004',
  'TRANSFERENCIA RECEBIDO DE IF': 'STR0004R2',
  'TED RECEBIDO DE CLIENTES PARA IF': 'STR0006R2',
  'TED RECEBIDO DE IF PARA CLIENTES': 'STR0007R2',
  'TED RECEBIDO DE CONTAS DE CLIENTES': 'STR0008R2',
  'ESTORNO DE TED': 'STR0010R2',
  'TED/TEV': 'STR0008',
  'TARIFA GENERICA': 'TARIFA ',
  'TARIFA DE MENSALIDADE': 'TARIFA_MENSAL',
  'TARIFA DE BOLETO VENCIDO': 'TARIFA_BOLETO_VENCIDO',
  'TARIFA DE BOLETO LIQUIDADO': 'TARIFA_BOLETO',
  'TARIFA DE ALTERACAO DE BOLETO': 'TARIFA_ALTERACAO_BOLETO ',
  'TARIFA DE ABERTURA DE CONTA PF': 'TARIFA_ABERTURA_CONTA_PF',
  'TARIFA DE ABERTURA DE CONTA PJ': 'TARIFA_ABERTURA_CONTA_PJ',
  'TARIFA DE BOLETO BAIXADO': 'TARIFA_BAIXADO',
  'TARIFA PARA COMPRA DE CRIPTO': 'TARIFA_CRIPTO_COMPRA',
  'TARIFA PARA VENDA DE CRIPTO': 'TARIFA_CRIPTO_VENDA',
  'TARIFA PIX': 'TARIFA_PIX',
  'TARIFA PIX DEVOLUÇÃO': 'TARIFA_RECEBIMENTO_PIX_DEVOLUCAO',
  'TARIFA DE ABERTURA DE CONTA ESCROW': 'TARIFA_ABERTURA_CONTA_ESCROW',
  'TARIFA DE SAQUE DO CARTAO': 'TARIFA_CARTAO_SAQUE',
  'TARIFA DE GERACAO DE QRCODE': 'TARIFA_PIX_GERAR_QRCODE',
  'TARIFA DE SOLICITACAO DE CARTAO': 'TARIFA_CARTAO_SOLICITACAO',
  'TARIFA DE RECEBIMENTO DE PIX': 'TARIFA_RECEBIMENTO_PIX',
  'TARIFA DE RECEBIMENTO DE TED': 'TARIFA_RECEBIMENTO_TED',
  'TARIFA DE RECEBIMENTO DE BOLETO LIQUIDADO': 'TARIFA_RECEBIMENTO_BOLETO',
  'TARIFA DE RECEBIMENTO DE TEV': 'TARIFA_RECEBIMENTO_TEV',
  'TARIFA DE TED': 'TAXA_TED',
};

export function setTypeOperation(codmsg: string | undefined) {
  if (codmsg !== undefined) {
    switch (codmsg) {
      case 'TARIFA_CRIPTO_COMPRA':
      case 'TARIFA_CRIPTO_VENDA':
      case 'TARIFA_MENSAL':
      case 'TARIFA_BOLETO':
      case 'TARIFA_ALTERACAO_BOLETO':
      case 'TARIFA_ABERTURA_CONTA_PF':
      case 'TARIFA_BAIXADO':
      case 'TARIFA_PIX':
      case 'TARIFA':
      case 'TARIFA_RECEBIMENTO_PIX_DEVOLUCAO':
      case 'TARIFA_CARTAO_SAQUE':
      case 'TARIFA_ABERTURA_CONTA_PJ':
      case 'TARIFA_RECEBIMENTO_TED':
      case 'TARIFA_ABERTURA_CONTA_ESCROW':
      case 'TARIFA_PIX_GERAR_QRCODE':
      case 'TARIFA_CARTAO_SOLICITACAO':
      case 'TARIFA_RECEBIMENTO_BOLETO':
      case 'TARIFA_ABERTURA_CONTA_CONSIGNADA':
      case 'TARIFA_RECEBIMENTO_TEV':
      case 'TARIFA_RECEBIMENTO_PIX':
      case 'TARIFA_BOLETO_VENCIDO':
        return 'TARIFA';

      case 'BOLETO_CREDITO':
        return 'BOLETO';

      case 'ASLC024':
      case 'ASLC022':
        return 'DOMICILIO';
      case 'ASLC032':
        return 'ANTECIPACAO';

      case 'CARTAO_00_PURCHASE':
      case 'CARTAO_01_CASH_WITHDRAW':
        return 'CARTAO';

      case 'STR0004R2':
      case 'STR0004':
        return 'TRANSFERENCIA IF';

      case 'CRIPTO_COMPRA':
      case 'CRIPTO_VENDA':
        return 'CRIPTO';

      case 'STR0008R2':
      case 'STR0010R2':
      case 'TAXA_TED':
      case 'STR0006R2':
      case 'STR0008':
      case 'STR0007R2':
        return 'TED';

      case 'Recarga':
        return 'RECARGA';

      case 'Pix':
        return 'Pix';

      case 'Pix_Devolucao':
        return 'Pix Devolução';

      case 'SLB0002':
        return 'PAGAMENTO';

      default:
    }
  }
  return 'OUTROS';
}

export function returnStatusAnaliticData(character: string): string {
  switch (character) {
    case 'R':
      return 'Realizado';
    case 'P':
      return 'Pendente';
    case 'C':
      return 'Cancelado';
    case 'E':
      return 'Erro';
    case 'G':
      return 'Estorno';

    default:
      return 'Não identificado';
  }
}

export function returnATypeAnaliticData(item: IAnaliticData) {
  if (item.messageCode === 'Recarga') {
    return 'Boleto';
  }

  if (item.messageCode === 'Boleto') {
    return 'Pagamento de Boleto';
  }

  if (
    item.messageCode === 'BOLETO_CREDITO' &&
    item.transactionStatus === 'R' &&
    item.customerCnpjCpfCredited !== item.customerCnpjCpfDebited
  ) {
    return 'Boleto liquídado';
  }

  if (
    item.messageCode === 'BOLETO_CREDITO' &&
    item.customerCnpjCpfCredited === item.customerCnpjCpfDebited &&
    item.transactionStatus === 'R'
  ) {
    return 'Boleto Fidúcia';
  }

  if (item.messageCode === 'BOLETO_CREDITO' && item.transactionStatus === 'E') {
    return 'Estorno de Boleto liquídado';
  }

  if (item.messageCode === 'TARIFA_BOLETO' && item.transactionStatus === 'R') {
    return 'Tarifa boleto liquidado';
  }

  if (item.messageCode === 'TARIFA_BOLETO' && item.transactionStatus === 'E') {
    return 'Estorno Tarifa boleto liquidado';
  }

  if (item.messageCode === 'STR0010R2') {
    return `Estorno de TED de ${item.bankIdDebited}`;
  }

  if (item.messageCode === 'TARIFA_MENSAL') {
    return 'Tarifa de manutenção de conta';
  }

  if (item.messageCode === 'TARIFA_BOLETO_VENCIDO') {
    return 'Tarifa de boleto vencido';
  }

  if (item.messageCode === 'TARIFA_ALTERACAO_BOLETO') {
    return 'Tarifa alteração de boleto';
  }

  if (item.messageCode === 'TARIFA_ABERTURA_CONTA_PF') {
    return 'Tarifa abertura de conta PF';
  }

  if (item.messageCode === 'TARIFA_ABERTURA_CONTA_PJ') {
    return 'Tarifa abertura de conta PJ';
  }

  if (item.messageCode === 'TARIFA_ABERTURA_CONTA_ESCROW') {
    return 'Tarifa de abertura de conta escrow';
  }

  if (item.messageCode === 'TARIFA_ABERTURA_CONTA_CONSIGNADA') {
    return 'Tarifa de abertura de conta consignada';
  }

  if (item.messageCode === 'TARIFA_BAIXADO') {
    return 'Tarifa baixa de boleto';
  }

  if (item.messageCode === 'TAXA_TED') {
    return 'Tarifa de TED';
  }

  if (item.messageCode === 'STR0007R2') {
    return `Transferência recebida de: ${item.bankIdDebited}`;
  }

  if (item.messageCode === 'Pix') {
    return 'Pix';
  }

  if (!isIspbFiducia(item.creditedBankId) && item.messageCode === 'STR0008') {
    return `TED enviada para ${capitalize(item.customerNameCredited)}`;
  }

  if (
    item.messageCode === 'STR0008' ||
    (item.messageCode === 'STR0008' && item.transactionStatus === 'R') ||
    (item.messageCode === 'STR0008' && item.transactionStatus === 'G')
  ) {
    return `TEV enviada para ${capitalize(item.customerNameCredited)}`;
  }

  if (
    item.messageCode === 'STR0008' ||
    (item.messageCode === 'STR0008' && item.transactionStatus === 'E')
  ) {
    return `Erro na Transferência enviada para ${capitalize(
      item.customerNameCredited
    )}`;
  }

  if (item.messageCode === 'STR0008') {
    return `Transferência recebida de ${capitalize(item.customerNameDebited)}`;
  }

  if (item.messageCode === 'STR0008R2') {
    return `Transferência recebida de ${capitalize(item.customerNameCredited)}`;
  }

  if (item.messageCode === 'STR0006R2') {
    return `Transferência recebida de ${capitalize(item.customerNameDebited)}`;
  }

  if (item.messageCode === 'SLB0002') {
    return 'SLB - Pagamento de Lançamento BACEN';
  }

  if (item.messageCode === 'STR0004') {
    return `TIB Paga - Transferência para IF ${item.creditedBankId}`;
  }

  if (item.messageCode === 'STR0004R2') {
    return `TIB Recebida - Transferência de IF ${item.bankIdDebited}`;
  }

  return 'Desconhecido';
}
